import { z } from 'zod'

export const AdminRegistryConfig = z.object({
  id: z.number(),
  status: z.string(),
  region: z.string(),
  shard: z.string(),
  slug: z.string(),
  account_id: z.number(),
  account_email: z.string(),
  storage_bytes: z.number(),
  created_at: z.string()
})
export type AdminRegistryConfig = z.infer<typeof AdminRegistryConfig>

export const AdminRegistryToken = z.object({
  id: z.number(),
  name: z.string(),
  token_prefix: z.string(),
  active: z.boolean(),
  scopes: z.array(z.string()).nullable().optional(),
  pull_only: z.boolean().optional(),
  created_at: z.string(),
  last_used: z.string().nullable().optional(),
  expires_at: z.string().nullable().optional()
})
export type AdminRegistryToken = z.infer<typeof AdminRegistryToken>

export const AdminRegistryUsageRecord = z.object({
  id: z.number(),
  period_start: z.string(),
  period_end: z.string(),
  storage_bytes: z.number(),
  egress_bytes: z.number(),
  pull_count: z.number(),
  push_count: z.number(),
  reported_to_stripe: z.boolean()
})
export type AdminRegistryUsageRecord = z.infer<typeof AdminRegistryUsageRecord>

export const AdminRegistryCleanupRule = z.object({
  id: z.number(),
  repository: z.string(),
  rule_type: z.string(),
  value: z.number(),
  keep_patterns: z.array(z.string()).nullable().optional(),
  delete_patterns: z.array(z.string()).nullable().optional(),
  enabled: z.boolean()
})
export type AdminRegistryCleanupRule = z.infer<typeof AdminRegistryCleanupRule>

export const AdminRegistryDetails = z.object({
  id: z.number(),
  status: z.string(),
  region: z.string(),
  shard: z.string(),
  slug: z.string().optional(),
  storage_quota_bytes: z.number(),
  created_at: z.string(),
  account_id: z.number(),
  account_email: z.string(),
  stripe_subscription_id: z.string().nullable().optional(),
  stripe_storage_item_id: z.string().nullable().optional(),
  stripe_egress_item_id: z.string().nullable().optional(),
  tokens: z.array(AdminRegistryToken).optional(),
  usage_records: z.array(AdminRegistryUsageRecord).optional(),
  cleanup_rules: z.array(AdminRegistryCleanupRule).optional()
})
export type AdminRegistryDetails = z.infer<typeof AdminRegistryDetails>
